import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language?.startsWith("es") ? "es" : "en";

  const toggleLanguage = () => {
    const newLang = currentLang === "en" ? "es" : "en";
    i18n.changeLanguage(newLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      data-testid="language-switcher"
      className="flex items-center gap-1 sm:gap-1.5 px-1.5 sm:px-2.5 py-1.5 rounded-full text-[10px] sm:text-xs font-semibold transition-colors bg-[#006D77]/10 text-[#006D77] hover:bg-[#006D77]/20 flex-shrink-0"
      aria-label={`Switch to ${currentLang === "en" ? "Spanish" : "English"}`}
    >
      <Globe className="w-3 h-3 sm:w-3.5 sm:h-3.5" />
      <span>{currentLang === "en" ? "EN" : "ES"}</span>
    </button>
  );
};

export default LanguageSwitcher;
